import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type { GoalRecord } from 'webapp/models';

export default class GoalsInsightsDetailRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('account') declare accountService: Service.Account;
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;

	override beforeModel() {
		const promises = [this.mmMetricsService.requestMetrics()];
		return Promise.all(promises);
	}

	override model(params: { goal_id: string }): unknown {
		return this.mmGoalsService.findRecord(params.goal_id);
	}

	override afterModel(model: GoalRecord) {
		if (!model || this.accountService.isDemoAccount) {
			this.navigationService.replaceRoute('goals.my').then(() => {
				this.accountService.handleDemo();
			});
			return;
		}

		return this.mmGoalsService.requestSingleGoal(model.id!).finally(() => {
			document.body.id = 'page-goals-insights';
		});
	}
}
